export const GET_BOOKABLE_EVENT_TYPES_QUERY = `
  query GetBookableEventTypes {
    bookableEventTypes {
      id
      name
      description
      instructions
      capacity
      amountCents
      amountCurrency
      location
      kind
      photoUrl
      slug
      url
      duration
      durationUnit
    }
  }
`

export const GET_SCHEDULED_EVENTS_QUERY = `
  query GetScheduledEvents($bookableEventTypeId: ID!) {
    bookableEventType(id: $bookableEventTypeId) {
      id
      name
      bookableEvents {
        id
        startsAt
        endsAt
        timeZone
        clientsCount
        capacity
        atCapacity
      }
    }
  }
`
